"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("react");

var _context = _interopRequireDefault(require("./context"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
Maybe we should take a parameter such that when provided ddl state will be included
Otherwise it isn't
This would allow differentiation between components updating and subscribing.
*/
var useDDL = function useDDL() {
  var rawContext = (0, _react.useContext)(_context.default);
  return rawContext;
};

var _default = useDDL;
exports.default = _default;